export const isDev =
  process.env.REACT_APP_NODE_ENV === "development" &&
  process.env.REACT_APP_IS_LOCAL === "true";

const getUrl = () => {
  return `${
    isDev
      ? process.env.REACT_APP_URL_LOCAL
      : process.env.REACT_APP_ENV_PROD === "true"
      ? process.env.REACT_APP_API_URL
      : process.env.REACT_APP_API_URL_DEV
  }`;
};
export default getUrl;
